import './expo_page.css';
import React from 'react';
import { useNavigate } from 'react-router-dom';

import Profile from './img_profilo.png';

import { useTranslation } from 'react-i18next';

function Whoim() {

    const navigate = useNavigate();
    const { t } = useTranslation();

    return (
            <div className="main-wrapper">
            <div className="tools-wrapperS2">
                <div className="cv-container">
                    {/* ================= HERO ================= */}
                    <div className="cv-header">
                        <img
                            src={Profile}
                            alt="Profilo"
                            className="cv-photo"
                        />
                        <div className="cv-intro">
                            <h1>{t('pages.whoim.w1')}</h1>
                            <p className="cv-role">
                                {t('pages.whoim.w2')}
                            </p>
                        </div>
                    </div>

                    {/* ================= CHI SONO ================= */}
                    <div className="cv-section">
                        <h3>{t('pages.whoim.w3')}</h3>
                        <p>
                            {t('pages.whoim.w4')}
                        </p>
                        <p>
                            {t('pages.whoim.w5')}
                        </p>
                        <p>
                            {t('pages.whoim.w6')}
                        </p>
                    </div>

                    {/* ================= COMPETENZE ================= */}
                    <div className="cv-section">
                        <h3>{t('pages.whoim.w7')}</h3>
                        <div className="cv-skills">
                            <div>
                                <h4>{t('pages.whoim.w8')}</h4>
                                <ul>
                                    <li>{t('pages.whoim.w9')}</li>
                                    <li>{t('pages.whoim.w10')}</li>
                                    <li>{t('pages.whoim.w11')}</li>
                                    <li>{t('pages.whoim.w12')}</li>
                                </ul>
                            </div>

                            <div>
                                <h4>{t('pages.whoim.w13')}</h4>
                                <ul>
                                    <li>{t('pages.whoim.w14')}</li>
                                    <li>{t('pages.whoim.w15')}</li>
                                    <li>{t('pages.whoim.w16')}</li>
                                    <li>{t('pages.whoim.w17')}</li>
                                    <li>{t('pages.whoim.w18')}</li>
                                    <li>{t('pages.whoim.w19')}</li>
                                    <li>{t('pages.whoim.w20')}</li>
                                    <li>{t('pages.whoim.w21')}</li>
                                </ul>
                            </div>

                            <div>
                                <h4>{t('pages.whoim.w22')}</h4>
                                <ul>
                                    <li>{t('pages.whoim.w23')}</li>
                                    <li>{t('pages.whoim.w24')}</li>
                                    <li>{t('pages.whoim.w25')}</li>
                                    <li>{t('pages.whoim.w26')}</li>
                                </ul>
                            </div>

                        </div>
                    </div>

                    {/* ================= PROGETTO ================= */}
                    <div className="cv-section">
                        <h3>{t('pages.whoim.w27')}</h3>

                        <p>
                            {t('pages.whoim.w28')}
                        </p>

                        <ul>
                            <li>{t('pages.whoim.w29')}</li>
                            <li>{t('pages.whoim.w30')}</li>
                            <li>{t('pages.whoim.w31')}</li>
                        </ul>
                    </div>

                     {/* CTA BOTTONO / FRECCIA */}
                    <div className="cv-cta-examples" onClick={() => {navigate('/portfolio');window.scrollTo(0, 0);}}>
                        <h4>{t('pages.whoim.w32')} →</h4>
                    </div>
                </div>
            </div>

        </div>
    );
}

export default Whoim;
 

